// Account registration is not evidence that this seminar has been paid.
export function seminarApplicationCsv(participants, seminar, customers) {
  const headings = ['参加者氏名', '会員属性', '参加費', '領収状態', '登録支払方法', '第1部', '第2部', '第3部', '懇親会', '参加形態', '自由記入欄'];
  if (seminar.is_screening) headings.splice(2, 0, '常連選考');
  const rows = participants.map((participant) => {
    const member = participant.member || {};
    const customer = Array.isArray(customers) ? customers.find((entry) => entry.uuid === member.uuid) : null;
    const byStripe = customer?.stripe_customer?.by_stripe;
    const row = [
      `${member.last_name || ''}${member.first_name || ''}`,
      member.is_member ? '会員' : member.is_training_group_member ? '稽古会会員' : '非会員',
      participant.entrance_fee,
      participant.received_is ? '領収' : participant.entrance_fee === 0 ? '無料' : '未領収',
      byStripe === true ? 'クレジットカード' : byStripe === false ? '現金' : '不明',
      ...['part1', 'part2', 'part3', 'part4'].map((key) => participant[key] ? '参加' : '-'),
      participant.is_online ? 'オンライン' : '会場',
      participant.text,
    ];
    if (seminar.is_screening) row.splice(2, 0, participant.is_screening ? '常連' : '非常連');
    return row;
  });
  const quote = (value) => {
    const text = value == null ? '' : String(value);
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  return '\uFEFF' + [headings, ...rows].map((row) => row.map(quote).join(',')).join('\r\n') + '\r\n';
}
